import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import TourDetail from "./pages/TourDetail";
import AdventureBuilder from "./pages/AdventureBuilder";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import EBCReg from "./pages/EBCReg";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import TrekkerPortal from "./pages/TrekkerPortal";
import BookingDetail from "./pages/BookingDetail";
import AdminDashboard from "./pages/AdminDashboard";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ContactForm from "./components/ContactForm";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<><Home /><ContactForm /></>} />
      <Route path="/tour/:slug" element={<TourDetail />} />
      <Route path="/build-adventure" element={<AdventureBuilder />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/EBCreg" element={<EBCReg />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/portal"
        element={<ProtectedRoute><TrekkerPortal /></ProtectedRoute>}
      />
      <Route
        path="/portal/booking/:bookingId"
        element={<ProtectedRoute><BookingDetail /></ProtectedRoute>}
      />
      <Route
        path="/admin"
        element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>}
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Header />
            <AppRouter />
            <Footer />
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
